import React, { Component } from "react";
import {
    Paper,
    TableHead,
    Table,
    TableRow,
    Typography,
    TableCell,
    TableBody,
    Grid
} from "@material-ui/core";
import { connect } from "react-redux";
import { hot } from "react-hot-loader";
import {
    getUsers,
    getReportTypes,
    setToDateFilter,
    setFromDateFilter
} from "./actions";
import { Modal, ModalBody, Spinner } from "reactstrap";

class ReportTotalDetail extends Component {
    constructor(props) {
        super(props);
        props.getUsers();
        props.getReportTypes();
    }
    componentDidUpdate(nextProps, nextState) {
        if (nextProps.toDate !== this.props.toDate) {
            this.props.setToDateFilter(this.props.toDate);
        }
        if (nextProps.fromDate !== this.props.fromDate) {
            this.props.setFromDateFilter(this.props.fromDate);
        }
    }
    render() {
        const { reports, reportTypes, lg, md, sm } = this.props;
        return (
            <Grid item sm={sm} md={md} lg={lg}>
                <Paper
                    style={{
                        paddingTop: 10,
                        height: "100%",
                        overflow: "scroll"
                    }}
                >
                    <Modal isOpen={this.props.requesting} style={{maxWidth: "00px"}}>
                        <ModalBody>
                        {this.props.requesting && ( 
                        <div style={{textAlign: "center", paddingTop: "3em"}}>
                            <div style={{background: "white", width: 'fit-content', display: 'inline-block', padding: "2em"}}>
                                <Spinner
                                    style={{
                                        height: 100,
                                        width: 100,
                                        background: "white"
                                    }}
                                    color="primary"
                                />
                                <Typography
                                    style={{
                                        textAlign: "center",
                                        marginTop: 15,
                                        color: "rgba(0, 0, 0, 0.87)",
                                        fontWeight: "bolder",
                                        fontSize: 20

                                    }}
                                    variant="body2"
                                >
                                Processing...
                                </Typography>                                
                            </div>
                        </div>)}
                        </ModalBody>
                    </Modal>
                    <Table
                        style={{
                            marginTop: 20,
                            marginBottom: 20
                        }}
                    >
                        <TableHead>
                            <TableRow>
                                <TableCellHeader text="User Name" />
                                {reportTypes &&
                                    Object.keys(reportTypes).map((e, i) => {
                                        return (
                                            <TableCellHeader
                                                key={i}
                                                text={reportTypes[e]}
                                            />
                                        );
                                    })}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {reports &&
                                reports.map((e, i) => {
                                    return (
                                        <TableRow key={i}>
                                            <TableCellBody
                                                text={<b>{e.user_name}</b>}
                                            />
                                            {e.reportsInfo.map((f, i) => {
                                                return (
                                                    <TableCellBody
                                                        key={i}
                                                        text={f.total}
                                                    />
                                                );
                                            })}
                                        </TableRow>
                                    );
                                })}
                        </TableBody>
                    </Table>
                </Paper>
            </Grid>
        );
    }
}

const TableCellHeader = props => {
    return (
        <TableCell style={{ textAlign: "center" }}>
            <Typography variant="body2">
                <b>{props.text}</b>
            </Typography>
        </TableCell>
    );
};
const TableCellBody = props => {
    return (
        <TableCell style={{ textAlign: "center" }}>
            <Typography variant="body2">{props.text}</Typography>
        </TableCell>
    );
};
export default hot(module)(
    connect(
        (store, props) => {
            const { selectors } = props;
            const { selectReports, selectReportTypes, getRequesting } = selectors;
            return {
                reports: selectReports(store),
                reportTypes: selectReportTypes(store),
                requesting: getRequesting(store)
            };
        },
        { getUsers, getReportTypes, setToDateFilter, setFromDateFilter }
    )(ReportTotalDetail)
);
